/**
 * Utility to generate WhatsApp links with dynamic messages and tracking parameters
 */

export const getWhatsAppLink = (baseMessage: string) => {
  const PHONE_NUMBER = '18572715381'

  // Get UTM parameters from URL
  const params = new URLSearchParams(window.location.search)
  const utmSource = params.get('utm_source') || 'direct'
  const utmMedium = params.get('utm_medium') || ''
  const utmCampaign = params.get('utm_campaign') || ''

  // Construct the message with tracking info appended
  // We append it in a way that's visible to Pedro but not intrusive to the user
  let finalMessage = baseMessage

  // Add a new line and tracking info if UTMs exist
  if (utmSource !== 'direct' || utmCampaign) {
    finalMessage += `\n\n[Ref: ${utmSource}${utmCampaign ? '/' + utmCampaign : ''}]`
  }

  return `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(finalMessage)}`
}
